import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cmp-animated-input',
  template: `<div class="input-wrapper">
  <input type="text" id="" required>
  <label for="">Title Input</label>
</div>
`,
  styles: [`.input-wrapper{position:relative;line-height:14px;margin:0 10px}label{color:#bbb;font-size:16px;position:absolute;z-index:2;left:18px;top:14px;padding:0 2px;pointer-events:none;background:#fff;transition:transform .1s;transition:transform .1s,-webkit-transform .1s;-webkit-transform:translateY(-20px);transform:translateY(-20px)}input{font-size:14px;color:#555;outline:0;border:1px solid #bbb;padding:7px 15px;border-radius:4px;position:relative;width:100%}input:invalid+label{color:#ccc;-webkit-transform:translateY(-5px);transform:translateY(-5px)}input+label{color:#1b2734;-webkit-transform:translateY(-25px);transform:translateY(-25px)}`]
})
export class AnimatedInputComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
